import { render, staticRenderFns } from "./LiveHub.vue?vue&type=template&id=3182b7be"
import script from "./LiveHub.vue?vue&type=script&lang=js"
export * from "./LiveHub.vue?vue&type=script&lang=js"
import style0 from "./LiveHub.vue?vue&type=style&index=0&id=3182b7be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports